import Dexie from 'dexie';
import { localSchema } from './schema';

// Configuration de la base de données principale
export class OSCDataDatabase extends Dexie {
  constructor() {
    super('OSC_DataDB');
    
    // Incrémenter la version pour inclure la nouvelle table activityConfigs
    this.version(14).stores(localSchema);
  }
}

// Configuration de la base de données de sauvegarde
export class BackupDatabase extends Dexie {
  constructor() {
    super('OSC_BackupDB');
    
    this.version(1).stores({
      activityData: 'activityId, name, data, lastUpdated'
    });
  }
}

// Instances des bases de données
export const db = new OSCDataDatabase();
export const backupDb = new BackupDatabase(); 